function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import { withMedia } from 'react-media-query-hoc';
import { AgentRecommendationsGraphQL } from '@domain-group/fe-co-allhomes-agent-recommendations';
import { EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { PureCssStickySidebox, Separator } from '@domain-group/fe-co-allhomes-design-system';
import AllhomesListingCard, { AllhomesListingCardsTabs } from '@domain-group/fe-co-allhomes-listing-card';
import AgentArticles from './components/agent-articles';
import AllhomesAgentBody from './components/agent-body';
import AllhomesAgentModel from './components/agent-model';
import { agentProfileInteractionEvent } from './components/ga-helpers';
import { SideboxCard } from './components/sidebox-card';
import getCardProps from './components/get-card-props';
import { articleProps } from './common-props';
import useSendPageView from './wrappers/use-send-page-view';
import { useMoreAgentReviewsLazyQuery } from './more-agent-reviews.generated';
import * as styles from './allhomes-agent-profile-page.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AGENT_REVIEWS_PAGE_SIZE = 10;
var AllhomesAgentProfilePage = props => {
  var _props$details, _props$details2, _details$reviewProfil, _details$reviewProfil2, _props$details3, _props$details4, _props$details5, _props$details6;
  useSendPageView((_props$details = props.details) === null || _props$details === void 0 ? void 0 : _props$details.id, (_props$details2 = props.details) === null || _props$details2 === void 0 ? void 0 : _props$details2.name);
  var _useAllhomesApi = useAllhomesApi(),
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  var details = props.details;
  var _React$useState = React.useState((_details$reviewProfil = details === null || details === void 0 ? void 0 : (_details$reviewProfil2 = details.reviewProfile) === null || _details$reviewProfil2 === void 0 ? void 0 : _details$reviewProfil2.reviews) !== null && _details$reviewProfil !== void 0 ? _details$reviewProfil : []),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    loadedReviews = _React$useState2[0],
    setLoadedReviews = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    maxReviewsReached = _React$useState4[0],
    setMaxReviewsReached = _React$useState4[1];
  var _useMoreAgentReviewsL = useMoreAgentReviewsLazyQuery(),
    _useMoreAgentReviewsL2 = _slicedToArray(_useMoreAgentReviewsL, 2),
    initiateQuery = _useMoreAgentReviewsL2[0],
    _useMoreAgentReviewsL3 = _useMoreAgentReviewsL2[1],
    isLoading = _useMoreAgentReviewsL3.loading,
    isError = _useMoreAgentReviewsL3.error;
  var _props$media = props.media,
    smallTablet = _props$media.smallTablet,
    mobile = _props$media.mobile;
  var listingTabNames = {
    sales: 'Sale',
    rentals: 'Rental',
    sold: 'Sold',
    rented: 'Rented'
  };

  // GA event handlers
  var listingTabClickHandler = tab => {
    agentProfileInteractionEvent("Listings Tab - ".concat(listingTabNames[tab.id]));
  };
  var listingCardClickHandler = (listingId, tab) => {
    agentProfileInteractionEvent("Property Click - ".concat(listingTabNames[tab.id]));
  };
  var articlesLayout = () => {
    if (mobile) {
      return 'column';
    }
    if (smallTablet) {
      return 'two-row';
    }
    return 'row';
  };
  var loadMoreReviews = () => {
    initiateQuery({
      variables: {
        agentId: details === null || details === void 0 ? void 0 : details.id,
        pagination: {
          offset: loadedReviews.length,
          pageSize: AGENT_REVIEWS_PAGE_SIZE
        }
      }
    }).then(_ref => {
      var _data$agent, _data$agent$reviewPro;
      var data = _ref.data;
      var newReviews = (data === null || data === void 0 ? void 0 : (_data$agent = data.agent) === null || _data$agent === void 0 ? void 0 : (_data$agent$reviewPro = _data$agent.reviewProfile) === null || _data$agent$reviewPro === void 0 ? void 0 : _data$agent$reviewPro.reviews) || [];
      if (newReviews.length < AGENT_REVIEWS_PAGE_SIZE) {
        setMaxReviewsReached(true);
      }
      setLoadedReviews([...loadedReviews, ...newReviews]);
    });
  };
  var agentRecommendationProps = _objectSpread(_objectSpread({}, toggledFeatures[ToggledFeatureKey.FIND_AN_AGENT_PACKAGE_BRANDING] ? {
    version: 'new',
    loadMoreReviews,
    reviewProfile: _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$details3 = props.details) === null || _props$details3 === void 0 ? void 0 : _props$details3.reviewProfile), {}, {
      reviews: loadedReviews
    }),
    isLoading,
    isError,
    hideButton: maxReviewsReached
  } : {
    version: 'old',
    reviewProfile: props === null || props === void 0 ? void 0 : (_props$details4 = props.details) === null || _props$details4 === void 0 ? void 0 : _props$details4.reviewProfile
  }), {}, {
    brandingLevel: props === null || props === void 0 ? void 0 : (_props$details5 = props.details) === null || _props$details5 === void 0 ? void 0 : _props$details5.brandingLevel,
    heading: (_props$details6 = props.details) !== null && _props$details6 !== void 0 && _props$details6.name ? "".concat(props.details.name.split(' ')[0], "'s reviews") : undefined
  });
  return ___EmotionJSX(Fragment, null, ___EmotionJSX(EventBoundary, {
    name: "agent"
  }, ___EmotionJSX(AllhomesAgentBody, {
    profile: props.details,
    maxPreviewHeight: props.maxPreviewHeight,
    onEmailClick: props.onEmailClick
  }), props.articles.length > 0 && ___EmotionJSX(AgentArticles, {
    layout: articlesLayout(),
    articles: props.articles
  })), props.initialListings && ___EmotionJSX(AllhomesListingCardsTabs, {
    css: styles.listingCards,
    title: "Listings by ".concat(props.details.name),
    titleTagType: "h2",
    sourceId: props.details.id,
    sourceType: "agent",
    className: "allhomes-agent-profile__allhomes-listing-card-list",
    eventHandlers: {
      tabClicked: listingTabClickHandler,
      listingCardClicked: listingCardClickHandler,
      showAllClicked: props.onShowAll,
      showLessClicked: props.onShowLess
    },
    tabs: [{
      id: 'sales',
      label: 'For Sale',
      labelMobile: 'Sale',
      totalCount: props.initialListings.sales.total,
      initialSearchResult: props.initialListings.sales.listings,
      subTitle: "".concat(props.initialListings.sales.total, " ").concat(props.initialListings.sales.total > 1 ? 'properties' : 'property', " for sale"),
      duration: ''
    }, {
      id: 'rentals',
      label: 'For Rent',
      labelMobile: 'Rent',
      totalCount: props.initialListings.rentals.total,
      initialSearchResult: props.initialListings.rentals.listings,
      subTitle: "".concat(props.initialListings.rentals.total, " ").concat(props.initialListings.rentals.total > 1 ? 'properties' : 'property', " for rent"),
      duration: ''
    }, {
      id: 'sold',
      label: 'Sold',
      labelMobile: 'Sold',
      totalCount: props.initialListings.recentlySold.total,
      initialSearchResult: props.initialListings.recentlySold.listings,
      subTitle: "".concat(props.initialListings.recentlySold.total, " ").concat(props.initialListings.recentlySold.total > 1 ? 'properties' : 'property', " sold"),
      duration: "Last ".concat(props.listingVisibility.sale.duration, " ").concat(props.listingVisibility.sale.unit, "s")
    }, {
      id: 'rented',
      label: 'Rented',
      labelMobile: 'Rented',
      totalCount: props.initialListings.recentlyRented.total,
      initialSearchResult: props.initialListings.recentlyRented.listings,
      subTitle: "".concat(props.initialListings.recentlyRented.total, " ").concat(props.initialListings.recentlyRented.total > 1 ? 'properties' : 'property', " rented"),
      duration: "Last ".concat(props.listingVisibility.rent.duration, " ").concat(props.listingVisibility.rent.unit, "s")
    }]
  }), props.details.reviewProfile && ___EmotionJSX(Fragment, null, ___EmotionJSX(Separator, {
    css: styles.separator
  }), ___EmotionJSX("div", {
    css: styles.recommendations
  }, ___EmotionJSX(AgentRecommendationsGraphQL, agentRecommendationProps), toggledFeatures[ToggledFeatureKey.FIND_AN_AGENT_PACKAGE_BRANDING] && ___EmotionJSX("div", {
    css: styles.sticky
  }, ___EmotionJSX(PureCssStickySidebox, {
    topEdgeOffset: 81
  }, ___EmotionJSX(SideboxCard, _extends({}, getCardProps(props.details), {
    onEmailClick: props.onEmailClick
  })))))));
};
AllhomesAgentProfilePage.propTypes = {
  details: PropTypes.shape(AllhomesAgentModel).isRequired,
  onShowAll: PropTypes.func.isRequired,
  onShowLess: PropTypes.func.isRequired,
  maxPreviewHeight: PropTypes.number,
  initialListings: PropTypes.shape({
    sales: PropTypes.shape({
      listings: PropTypes.arrayOf(PropTypes.shape(AllhomesListingCard.propTypes)),
      total: PropTypes.number
    }),
    rentals: PropTypes.shape({
      listings: PropTypes.arrayOf(PropTypes.shape(AllhomesListingCard.propTypes)),
      total: PropTypes.number
    }),
    recentlySold: PropTypes.shape({
      listings: PropTypes.arrayOf(PropTypes.shape(AllhomesListingCard.propTypes)),
      total: PropTypes.number
    }),
    recentlyRented: PropTypes.shape({
      listings: PropTypes.arrayOf(PropTypes.shape(AllhomesListingCard.propTypes)),
      total: PropTypes.number
    })
  }),
  listingVisibility: PropTypes.shape({
    sale: PropTypes.shape({
      duration: PropTypes.string,
      unit: PropTypes.string
    }),
    rent: PropTypes.shape({
      duration: PropTypes.string,
      unit: PropTypes.string
    })
  }),
  media: PropTypes.shape({
    smallTablet: PropTypes.bool,
    mobile: PropTypes.bool
  }),
  articles: PropTypes.arrayOf(PropTypes.shape(articleProps)),
  onEmailClick: PropTypes.func
};
AllhomesAgentProfilePage.defaultProps = {
  maxPreviewHeight: undefined,
  initialListings: undefined,
  listingVisibility: {
    sale: {
      duration: '',
      unit: ''
    },
    rent: {
      duration: '',
      unit: ''
    }
  },
  media: {},
  articles: [],
  onEmailClick: () => {}
};
export default withMedia(AllhomesAgentProfilePage);